import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import adSpot from "../../assets/img/adSpot.jpg";

const AdminDashboardAds = () => {
  const [displayAds, setDisplayAds] = useState([]);
  const [adImage, setAdImage] = useState(adSpot);
  const [adLink, setAdLink] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const getUrlParameter = (name) => {
    name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
    const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    const results = regex.exec(window.location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  };

  // Get the token parameter from the URL
  const tokenParam = getUrlParameter("token");

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append(
        "Authorization",
        "Bearer " + (Cookies.get("token") || tokenParam)
      );

      const options = {
        method: "GET",
        headers: headers,
      };

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/ads/getAdsByScreen?screen=lDashboard",
          options
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();

        setDisplayAds(data["ads"]);
        setAdImage(data.ads[0]?.image || adSpot);
        setAdLink(data.ads[0]?.link || null);
      } catch (error) {
        console.error(error);
        setAdImage(adSpot);
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    if (displayAds.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % displayAds.length);
      }, 3200);

      return () => clearInterval(interval); // Cleanup interval on component unmount
    }
  }, [displayAds]);

  useEffect(() => {
    if (displayAds.length > 0) {
      console.log(currentIndex);
      setAdImage(displayAds[currentIndex].image || adSpot);
      setAdLink(displayAds[currentIndex].link || null);
    }
  }, [currentIndex, displayAds]);
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        paddingTop: "100%", // This makes height equal to width (1:1 ratio)
        borderRadius: "10px",
        overflow: "hidden",
      }}
    >
      <img
        src={adImage}
        onClick={(e) => {
          e.preventDefault();
          if (adLink) {
            let url = adLink;

            // Check if adLink starts with http:// or https://
            if (!/^https?:\/\//i.test(adLink)) {
              url = `https://${adLink}`;
            }

            console.log(url);
            window.open(url, "_blank");
          }
        }}
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "10px",
          cursor: adLink ? "pointer" : "default",
        }}
      />
    </div>
  );
};

export default AdminDashboardAds;
